import React from 'react';

import List from './channel/List'

function Channel(){
	return(
	
			<List/>
			
	
	);
}

export default Channel;